export const CloseCircle = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 23.22C6.07 23.22 1.25 18.4 1.25 12.47C1.25 6.53997 6.07 1.71997 12 1.71997C17.93 1.71997 22.75 6.53997 22.75 12.47C22.75 18.4 17.93 23.22 12 23.22ZM12 3.21997C6.9 3.21997 2.75 7.36997 2.75 12.47C2.75 17.57 6.9 21.72 12 21.72C17.1 21.72 21.25 17.57 21.25 12.47C21.25 7.36997 17.1 3.21997 12 3.21997Z" />
    <path d="M9.16986 16.05C8.97986 16.05 8.78986 15.98 8.63986 15.83C8.34986 15.54 8.34986 15.06 8.63986 14.77L14.2999 9.10996C14.5899 8.81996 15.0699 8.81996 15.3599 9.10996C15.6499 9.39996 15.6499 9.87996 15.3599 10.17L9.69986 15.83C9.55986 15.98 9.35986 16.05 9.16986 16.05Z" />
    <path d="M14.8299 16.05C14.6399 16.05 14.4499 15.98 14.2999 15.83L8.63986 10.17C8.34986 9.87996 8.34986 9.39996 8.63986 9.10996C8.92986 8.81996 9.40986 8.81996 9.69986 9.10996L15.3599 14.77C15.6499 15.06 15.6499 15.54 15.3599 15.83C15.2099 15.98 15.0199 16.05 14.8299 16.05Z" />
  </svg>
);
